import PropTypes from 'prop-types';
import React from 'react';
import { hot } from 'react-hot-loader';

const BasicButtons = props => {
	// const rgbBg = props.bgColor.replace('rgb(', '').replace(')', '');
	// const finalRgbBg = `rgba(${rgbBg}, ${props.opac})`;

	const cashoutRgbBg = `rgba(${props.bgColor?.replace('rgb(', '').replace(')', '')}, ${props.opac})`;

	let isInverted = props.inverted ? true : false;
	let styleWrapper = {
		display: 'flex',
		minWidth: '146px',
		height: '52px',
		padding: '0px 30px',
		justifyContent: 'center',
		alignItems: 'center',
		flexShrink: 0,
		borderRadius: '100px',
		cursor: 'pointer'
	};
	let styleText = {
		textAlign: 'center',
		fontFamily: 'Raleway',
		fontSize: '15px',
		fontStyle: 'normal',
		fontWeight: 700,
		lineHeight: '15px',
		letterSpacing: '1.25px',
		textTransform: 'uppercase'
	};
	if (!props.inverted) {
		switch (props.type) {
			case 'accept':
				styleWrapper.backgroundColor = '#25B78D';
				styleWrapper.border = '2px solid var(--Blue, #76C4EE)';
				styleText.color = '#FFF';
				break;
			case 'decline':
				styleWrapper.backgroundColor = '#FFF';
				styleWrapper.border = '2px solid var(--Blue, #76C4EE)';
				styleText.color = '#000000';
				break;
			case 'signup':
				styleWrapper.backgroundColor = '#25B78D';
				styleText.color = '#FFF';
				styleText.lineHeight = '15px';
				break;
			case 'login':
				styleWrapper.backgroundColor = '#FFF';
				styleWrapper.border = '1.5px solid var(--Green, #27B88D)';
				styleText.color = '#25B78D';
				styleText.lineHeight = '15px';
				break;
			case 'cashoutBankOptions':
				styleWrapper.height = '37px';
				styleWrapper.minWidth = '284px';
				styleWrapper.marginTop = '13px';
				styleWrapper.borderRadius = '26px';
				styleWrapper.backgroundColor = cashoutRgbBg;
				styleWrapper.border = `1.5px solid ${props.border}`;
				styleText.color = 'black';
				break;
			default:
				break;
		}
	} else {
		switch (props.type) {
			case 'accept':
				styleWrapper.backgroundColor = '#FFF';
				styleWrapper.border = '2px solid var(--Blue, #76C4EE)';
				styleText.color = '#000000';
				break;
			case 'decline':
				styleWrapper.backgroundColor = '#25B78D';
				styleWrapper.border = '2px solid var(--Blue, #76C4EE)';
				styleText.color = '#FFF';
				break;
			case 'signup':
				styleWrapper.backgroundColor = '#FFF';
				styleText.color = '#25B78D';
				styleText.lineHeight = '15px';
				break;
			case 'login':
				styleWrapper.backgroundColor = '#25B78D';
				styleWrapper.border = '1.5px solid var(--Green, #27B88D)';
				styleText.color = '#FFF';
				styleText.lineHeight = '15px';
				break;
			case 'cashoutBankOptions':
				styleWrapper.height = '37px';
				styleWrapper.minWidth = '284px';
				styleWrapper.marginTop = '13px';
				styleWrapper.borderRadius = '26px';
				styleWrapper.backgroundColor = props.bgColor;
				styleWrapper.border = `1.5px solid ${props.border}`;
				styleText.color = 'black';
				break;
			default:
				break;
		}
	}
	if (!props.onBoarding && props.type !== 'cashoutBankOptions') {
		styleWrapper.border = '2px solid var(--Blue, #76C4EE)';
	}
	return (
		<div onClick={props.onClick} style={{ ...styleWrapper, ...props.styleWrapper }}>
			<label style={{ ...styleText, margin: 0, cursor: 'pointer', ...props.styleText }}>
				{props.type != 'cashoutBankOptions'
					? !props.isLoaderOn
						? props.text.toUpperCase()
						: props.loader
					: props.text}
			</label>
		</div>
	);
};

BasicButtons.propTypes = {
	type: PropTypes.oneOf(['accept', 'decline', 'login', 'signup', 'cashoutBankOptions']),
	text: PropTypes.string.isRequired,
	inverted: PropTypes.bool,
	onBoarding: PropTypes.bool
};

export default hot(module)(BasicButtons);
